module.exports = __webpack_public_path__ + "static/media/Logo_MYSCB.6de8a20e.svg";